import {
  Stethoscope,
  Activity,
  Pill,
  HeartPulse,
  Brain,
  BookOpen,
} from "lucide-react";
import blog1 from "../assets/Blog1.png";

export const POSTS = [
  {
    id: 2,
    title: "The Next Healthcare Breakthrough? Giving Doctors Their Time Back.",
    excerpt:
      "Healthcare is becoming more digital, connected, and intelligent — but is technology actually giving doctors more time to care? The data reveals a challenge worth solving...",
    author: "Mr. Chandrasekaran S",
    authorImage:
      "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=200&h=200&fit=crop&crop=faces",
    date: "09/07/2026",
    icon: Brain,
    gradient: "linear-gradient(135deg,#071a3d,#189FAA)",
    image: blog1,

    // Each block has a "type":
    // "paragraph" -> normal text
    // "heading"   -> bold sub-heading
    // "bullets"   -> proper aligned list
    content: [
      {
        type: "paragraph",
        text: "Healthcare is becoming more digital, connected, and intelligent. But one question deserves greater attention: is technology giving doctors more time to care?",
      },
      {
        type: "paragraph",
        text: "The numbers reveal an important challenge. Research has found that physicians can spend approximately 49.2% of their workday on EHR and administrative tasks, compared with just 27% on direct clinical interaction with patients. Another study found that physicians spent around 35% of their time documenting patient data. These are not just productivity statistics — they represent a fundamental healthcare challenge.",
      },
      {
        type: "heading",
        text: "When Technology Demands More Time Than It Gives Back",
      },
      {
        type: "paragraph",
        text: "Healthcare organisations worldwide continue to invest in digital transformation — more platforms, more data, more automation, more connected devices. Yet adding more technology does not automatically create better healthcare. The real question is: how much measurable value is technology returning to doctors and patients?",
      },
      {
        type: "paragraph",
        text: "The relationship between technology experience and physician well-being is also significant. Research reported by the American Medical Association found that every 1-point improvement in EHR usability was associated with 3% lower odds of physician burnout. Healthcare technology should not simply be measured by the number of features, users, or records processed — it should also be measured by its impact.",
      },
      {
        type: "heading",
        text: "The Next Generation of Healthcare Needs New Metrics",
      },
      {
        type: "paragraph",
        text: "What if we started measuring digital health transformation differently?",
      },
      {
        type: "bullets",
        items: [
          "% reduction in administrative time",
          "% improvement in access to meaningful patient information",
          "% reduction in documentation burden",
          "% improvement in timely patient follow-ups",
          "% increase in meaningful doctor-patient interaction",
        ],
      },
      {
        type: "paragraph",
        text: "These are more than technology KPIs — they are healthcare impact metrics.",
      },
      {
        type: "paragraph",
        text: "Evidence suggests that workflow redesign can produce measurable gains. A 2024 national cohort study of more than 18,000 physicians found that team-based documentation support was associated with a 9.1% reduction in documentation time and a 6% increase in visit volume. After a 20-week learning period, documentation time decreased by 16.2%, while visits increased by 10.8%.",
      },
      {
        type: "heading",
        text: "From More Technology to More Meaningful Technology",
      },
      {
        type: "paragraph",
        text: "The future of digital healthcare cannot simply be about digitising more information — it must be about creating connected intelligence:",
      },
      {
        type: "bullets",
        items: [
          "The right information",
          "For the right healthcare professional",
          "At the right moment",
          "With less complexity",
          "Greater continuity of care",
        ],
      },
      {
        type: "paragraph",
        text: "At Doxzon, we believe technology should work around doctors, not make doctors work around technology — through connected patient information, simplified workflows, better continuity of care, informed clinical decisions, and stronger doctor-patient connections.",
      },
      {
        type: "heading",
        text: "Perhaps the Most Important Healthcare Metric Is Time",
      },
      {
        type: "paragraph",
        text: "Imagine the impact of returning even 10% more meaningful time to a doctor:",
      },
      {
        type: "bullets",
        items: [
          "More time to listen",
          "More time to understand",
          "More time to make informed decisions",
          "More time to care",
        ],
      },
      {
        type: "paragraph",
        text: "Multiply that across thousands of doctors and millions of patient interactions, and efficiency becomes something much bigger: it becomes healthcare transformation.",
      },
      {
        type: "paragraph",
        text: "The next era of healthcare will not be defined by who has the most technology. It will be defined by who uses technology to create the greatest measurable human impact. At Doxzon, that is the future we are working towards — connected technology, empowered doctors, better healthcare.",
      },
    ],
  },
];